/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useRef, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import AuthService from '../../services/AuthService';
import GeneralService from '../../services/GeneralService';

const UserVerification = props => {

    // states
    const [response, setResponse] = useState({ isEmailVerified: false, isPhoneVerified: false, message: { msgError: false, msgBody: "" } });
    const [error, setError] = useState({ msgError: false, msgBody: "" });
    const [loading, setLoading] = useState(true);
    let timerID = useRef(null);

    //variables
    var user = { token: '', type: '' };

    useEffect(() => {
        try {
            user.token = props.match.params.token;
            user.type = props.match.params.type;
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User UserVerification useEffect', 'Error in try catch block', err.stack);
        }
        AuthService.verifyUser(user)
            .then(data => {
                try {
                    setResponse(data);
                    setLoading(false);
                    timerID = setTimeout(() => {
                        props.history.push('/user/signin');
                    }, 2000);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at User UserVerification useEffect', 'Error in try catch block', err.stack);
                }
            })
            .catch(error => {
                setResponse(error);
                setError(error.message);
                setLoading(false);
            })
        return () => {
            clearTimeout(timerID)
        }
    }, []);

    // function's return
    return (
        <div>
            {
                loading ?
                    <h1>Loading</h1>
                    :
                    response.message.msgError ?
                        <h1>{response.message.msgBody}</h1>
                        :
                        response.isEmailVerified ?
                            <h1>Your email is verified</h1>
                            : response.isPhoneVerified ?
                                <h1>Your phone is verified</h1>
                                : null
            }
        </div>
    )


}

export default UserVerification;